export default function backgroundImage() {
  return {
    link: function(scope, element, attrs) {
      return attrs.$observe('backgroundImage', function(value) {
        return element.css({
          'background-image': 'url(' + value + ')'
        });
      });
    }
  };
}
